import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Divider, Flex, Image } from '@chakra-ui/react';
import { Path } from 'history';

import { Feature } from '__generated__/GQL';
import heartboxImg from 'assets/brand/box.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import { SupportedFeaturePreview } from 'features/Upgrade/types';
import * as Layout from 'layouts/StepperLayout';

import * as routes from '../../../../../PaymentCards/routes';
import locales from './locales';

const REDIRECT_AFTER_UPGRADE_PATHS: Record<SupportedFeaturePreview, Path> = {
  [Feature.BulkTransfers]: '/payments/transfers/bulk',
};

interface UpgradeSuccessProps {
  featurePreview?: SupportedFeaturePreview;
  planName: string;
}

const UpgradeSuccess: FC<UpgradeSuccessProps> = ({
  featurePreview,
  planName,
}) => {
  const isComingFromFeaturePreview = featurePreview !== undefined;

  const description = isComingFromFeaturePreview
    ? locales.formatString(locales.canAccessFeature, {
        feature: locales.features[featurePreview],
      })
    : locales.couldOrderCard;

  const redirectAfterUpgrade = isComingFromFeaturePreview
    ? REDIRECT_AFTER_UPGRADE_PATHS[featurePreview]
    : routes.orderNew;

  return (
    <Layout.Root>
      <Layout.Body>
        <SunshineCard padding="space-0" width={600}>
          <Flex direction="column" paddingTop="space-40">
            <Image height={180} objectFit="contain" src={heartboxImg} />

            <Heading
              marginTop="space-24"
              paddingX="space-32"
              size="lg"
              textAlign="center"
            >
              {locales.formatString(locales.title, { planName })}
            </Heading>

            <Text marginTop="space-16" paddingX="space-32" textAlign="center">
              {description}
            </Text>

            <Divider marginTop="space-40" />

            <Flex align="center" direction="column" padding="space-24">
              <Button
                as={Link}
                icon="arrow-right"
                marginBottom="space-0"
                textAlign="center"
                to={redirectAfterUpgrade}
              >
                {isComingFromFeaturePreview
                  ? locales.continue
                  : locales.orderCard}
              </Button>

              {!isComingFromFeaturePreview ? (
                <Button
                  as={Link}
                  marginTop="space-16"
                  to="/"
                  variant="inline-secondary"
                >
                  {locales.later}
                </Button>
              ) : null}
            </Flex>
          </Flex>
        </SunshineCard>
      </Layout.Body>
    </Layout.Root>
  );
};

export default UpgradeSuccess;
